"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ROLE_MAP = void 0;
var ROLE_MAP = {
  COLLABORATOR: "CAN EDIT",
  GUEST: "CAN VIEW",
  GUEST_COMMENTER: "CAN VIEW & COMMENT",
  NONE: "NONE",
  OWNER: "OWNER"
};
exports.ROLE_MAP = ROLE_MAP;